const initialState = {
    arr: []
}

const seaBookUploadRed = (state = initialState, action) => {
    switch(action.type){
        case 'SEABOOK_UPLOAD' : {
            return {
                ...state,
                arr: action.arr
            }
        }
        default: {
            return state
        }
    }
}

export default seaBookUploadRed